<template>
  <el-descriptions
    :column="2"
    :colon="false"
    direction="vertical"
    labelClassName="desc-label"
    contentClassName="desc-content"
  >
    <el-descriptions-item
      v-for="(item, index) in config"
      :label="item.label"
      :key="index"
    >
      {{ transformContent(item.key) || '--' }}
    </el-descriptions-item>
  </el-descriptions>
</template>
<script setup>
const props = defineProps({
  // 数据
  data: {
    type: Object,
    default: () => ({}),
  },
  /**
   *  字段配置 Array
   *  @property key：对应数据中的字段
   *  @property label：显示的标签
   *  @property getText：展示的值
   */
  config: {
    type: Array,
    default: () => [],
  },
})

// 数据转换
const transformContent = (key) => {
  const itemConfig = props.config.find((item) => item.key === key)
  if (itemConfig.getText && typeof itemConfig.getText === 'function') return itemConfig.getText(props.data[key])
  return props.data[key]
}
</script>
<style lang="scss" scoped>
::v-deep {
  .desc-label {
    font-size: 14px;
    color: #909399;
  }
  .desc-content {
    font-size: 14px;
    margin-bottom: 32px;
  }
  .el-descriptions--small:not(.is-bordered) .el-descriptions-item__cell {
    vertical-align: top;
  }
}
</style>
